// components/icons/icons.ts
import { BookCheck, BookUser, Building2, CalendarDays, Camera, ChartNoAxesCombined, Check, ChevronLeft, ChevronRight, CreditCard, Eye, FileCheck2, HandCoins, LockKeyhole, PencilLine, RefreshCcw, ScrollText, SquareUserRound, TvMinimalPlay, User, Wallet, X } from 'lucide-react';

export const icons = {
  'book-check': BookCheck,
  'book-user': BookUser,
  'building-2': Building2,
  'calendar-days': CalendarDays,
  'camera': Camera,
  'chart-no-axes-combined': ChartNoAxesCombined,
  'check': Check,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'credit-card': CreditCard,
  'eye': Eye,
  'file-check-2': FileCheck2,
  'hand-coins': HandCoins,
  'lock-keyhole': LockKeyhole,
  'pencil-line': PencilLine,
  'refresh-ccw': RefreshCcw,
  'scroll-text': ScrollText,
  'square-user-round': SquareUserRound,
  'tv-minimal-play': TvMinimalPlay,
  'user': User,
  'wallet': Wallet,
  'x': X,
} as const;
